import { SVG_ShiftRect } from "./SVG_ShiftRect";
import { QRoundRect } from "../CoreApp/QRoundRect";
import { SVG_CreateTriPath2 } from "./SVG_CreateTriPath2";
import { enumBoxShapes, kRoundRectRadius, enumFillMode } from "../constants";
import { Div2Floor } from "./Div2Floor.js";

export function SVG_DrawTri2(
  sx,
  sy,
  width,
  height,
  triColor,
  subTriColor,
  triPosition,
  doInset,
  boxShape,
  svgElement,
  triType,
  strokeColor,
  opacity
) {
  var bounds = new QRoundRect();
  var ax = null;
  var ay = null;
  var cx = null;
  var cy = null;
  if (triType === enumFillMode.centertriangle) {
    ax = sx;
    ay = sy - height;
    cx = ax + width;
    cy = sy;
  } else {
    var ey = sy + height; // end y
    var inset = 2;
    var ex = sx + width;
    if (!doInset) inset = 0;

    var h = ey - sy - inset * 2;
    ax = ex - inset - h;
    cx = ex - inset;

    cy = ey - inset;
    ay = sy + inset;

    if (triPosition === 1) {
      ax = sx + inset;
      cx = ax + inset + width;
    }
  }

  bounds.InitRoundRect(ax, ay, cx, cy, kRoundRectRadius);

  SVG_ShiftRect(bounds, svgElement);

  if (triColor != null) {
    var p = SVG_CreateTriPath2(bounds, boxShape, triPosition);
    if (strokeColor != null) p.setAttribute("stroke", strokeColor);
    p.setAttribute("fill", triColor);
    if (opacity != null) {
      p.setAttribute("fill-opacity", opacity);
      p.setAttribute("stroke-opacity", opacity);
    }
    svgElement.appendChild(p);
  }
  if (subTriColor != null) {
    var h2 = Div2Floor(h);
    ay = ay + h2;
    // drawing left to right in both cases
    if (triPosition === 1) cx = cx - h2;
    else ax = ax + h2;
    bounds.InitRoundRect(ax, ay, cx, cy, kRoundRectRadius);
    SVG_ShiftRect(bounds, svgElement);
    var p2 = SVG_CreateTriPath2(bounds, enumBoxShapes.rectangle, triPosition);
    p2.setAttribute("fill", subTriColor);
    svgElement.appendChild(p2);
  }
}
